import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./assets/styles/App.css";

import Header from "./components/common/Header";
import Home from "./pages/Home";
import BachilleratoHome from "./pages/Bachillerato";
import SectionPage from "./pages/SectionPage";
import CertificacionesHome from "./pages/Certificaciones";
import Contact from "./pages/Contact";
import AvisoPrivacidad from "./pages/AvisoPrivacidad";
import EducativeOfferDetail from "./pages/EducativeOfferDetail";
import Footer from "./components/common/Footer";
import ErrorBoundary from "./components/common/ErrorBoundary";
import WhatsAppBtn from "./components/common/WhatsAppBtn";

function App() {
  return (
    <React.Fragment>
      <Router>
        <Header />
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bachillerato" element={<BachilleratoHome />} />
          <Route
            path="/certificaciones"
            element={<CertificacionesHome />}
          />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />

          {/* Categorías dinámicas: cualquier /:section lista sus ofertas y /:section/:curso el detalle.
              Las rutas estáticas de arriba (/, /bachillerato, /contacto, /aviso-de-privacidad, /certificaciones) tienen
              prioridad por especificidad en react-router v6. Agregar "doctorados" = solo datos. */}
          <Route path="/:section" element={<SectionPage />} />
          <Route path="/:section/:courseName" element={<EducativeOfferDetail />} />
        </Routes>
        </ErrorBoundary>
        <Footer />
      </Router>
      <WhatsAppBtn />
    </React.Fragment>
  );
}

export default App;
